import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface NotificationsState {
	isNotificationsOpen: boolean
}

const initialState: NotificationsState = {
	isNotificationsOpen: false,
}

export const notificationsSlice = createSlice({
	name: 'notifications',
	initialState,
	reducers: {
		setNotificationsOpen: (state, action: PayloadAction<boolean>) => {
			state.isNotificationsOpen = action.payload
		},
	},
})

export const notificationsActions = notificationsSlice.actions
export const notificationsReducer = notificationsSlice.reducer
